import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { throwUnknownPortalTypeError } from '@angular/cdk/portal/portal-errors';

@Component({
	selector: 'app-edit-json-array',
	template: `
		<div fxLayout='column'>
			<div fxLayout='row' fxLayoutAlign='start center'>
				<ng-content></ng-content>
				<button *ngIf='!edit' type='button' mat-icon-button (click)='startEdit()'>
					<mat-icon style='font-size: 18px'>edit</mat-icon>
				</button>
			</div>

			<!--<code>
				<pre>{{json | json}}</pre>
			</code>-->

			<div *ngIf='!edit'>
				<div *ngFor='let item of items' fxLayout='column'>
					<a *ngIf="type == 'links'" (click)='openLink(item.link)' target='_blank'
					>{{ item.key }}
						<mat-icon style='font-size: 14px' [matTooltip]='item.link' matTooltipPosition='right'>open_in_new</mat-icon>
					</a>
					<div *ngIf="type == 'contacts'">
						<span>{{ item.key }}</span>
						<span *ngIf='item.role'>{{ " - " + item.role }}</span>
						<span *ngIf='item.mail'>{{ " - " + item.mail }}</span>
					</div>
				</div>
			</div>

			<div *ngIf='edit'>
				<div *ngFor='let item of items' fxLayout='row' fxLayoutAlign='start center'>  <!-- fxLayout='row wrap'  -->
					<mat-form-field style='margin: 0; padding: 0' appearance='standard'>
						<mat-label>Name</mat-label>
						<input matInput value='name' [(ngModel)]='item.key' />
					</mat-form-field>
					<div style='width: 10px'></div>
					<mat-form-field *ngIf='type == "links"' style='margin: 0; padding: 0' appearance='standard'>
						<mat-label>Link</mat-label>
						<input matInput value='link' [(ngModel)]='item.link' />
					</mat-form-field>
					<mat-form-field *ngIf='type == "contacts"' style='margin: 0; padding: 0' appearance='standard'>
						<mat-label>{{	"PROJECT.CUSTOMER_ROLE" | translate	}}</mat-label>
						<input matInput value='role' [(ngModel)]='item.role' />
					</mat-form-field>
					<div style='width: 10px'></div>
					<mat-form-field *ngIf='type == "contacts"' style='margin: 0; padding: 0' appearance='standard'>
						<mat-label>{{	"PROJECT.CUSTOMER_EMAIL" | translate	}}</mat-label>
						<input matInput value='mail' [(ngModel)]='item.mail' />
					</mat-form-field>
					<button type='button' mat-icon-button (click)='delete(item)'>
						<mat-icon>delete</mat-icon>
					</button>
				</div>
				<button type='button' mat-icon-button (click)='addNew()'>
					<mat-icon>add</mat-icon>
				</button>
				<button type='button' mat-icon-button (click)='save()'>
					<mat-icon>check</mat-icon>
				</button>
				<button type='button' mat-icon-button (click)='ngOnInit()'>
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>
	`,
	styles: [``],
})
export class EditJsonArray implements OnInit {
	@Input() type: string = 'links';
	@Input() proposeKeys: string = '';
	@Input() jsonString: string;
	@Input() items;
	@Output() jsonStringChange: EventEmitter<any> = new EventEmitter();
	@Output() blur: EventEmitter<any> = new EventEmitter();
	edit: boolean = false;

	constructor() {}

	ngOnInit(): void {
		this.edit = false;
		this.items = [];
		try {
			this.items = JSON.parse(this.jsonString);
		} catch (e) {
			console.error('EditJsonArray - input not JSON', this.jsonString);
		}

		// @ts-ignore
		if (!this.items || !Array.isArray(this.items) || this.items.length == 0 || !this.items[0].key) {
			console.error('EditJsonArray - input not consistent', this.jsonString);
			this.items = [];
		}
	}

	save(): void {
		this.items = this.items.filter((item) => {
			if (this.type == "links") return !!item.key && !!item.link;
			return !!item.key;
		})
		this.jsonString = JSON.stringify(this.items);
		this.jsonStringChange.emit(this.jsonString);
		this.blur.emit();
		this.edit = false;
	}

	addNew(key = "") {
		if (this.type == "links") {
			this.items.push({ key: key, link: '' });
		}
		if (this.type == "contacts") {
			this.items.push({ key: key, role: '', mail:'' });
		}
	}

	delete(item: any) {
		for (let i in this.items) {
			if (this.items[i].key == item.key) {
				this.items.splice(i, 1);
				return;
			}
		}
	}

	openLink(url) {
		window.open(url, "_blank");
	}

	startEdit() {
		try {
			if (this.proposeKeys) {
				const keys = this.proposeKeys.split(",");
				for (const key of keys) {
					if (!this.items.find(el => el.key.toLowerCase() == key?.toLowerCase())) {
						this.addNew(key);
					}
				}
			}
		}
		catch(e) {
			console.error(e);
		}


		this.edit = true;
	}
}
